module.exports = __webpack_public_path__ + "img/code-reviewer.1cabdd62.jpeg";